import React, { useState, useEffect } from "react";

export default function InviteModal({ open, onClose, onSend, maxBalance }) {
  const minBet = 0.5;
  const maxBet = Math.max(minBet, +(maxBalance - minBet).toFixed(2));
  const [bet, setBet] = useState(minBet);
  const [err, setErr] = useState("");

  // Reset on open
  useEffect(() => {
    setBet(minBet);
    setErr("");
  }, [open, maxBalance]);

  // Validate on input change
  const handleChange = (e) => {
    let v = e.target.value;
    // Only allow numbers and dot
    if (/[^0-9.]/.test(v)) return;
    let value = Number(v);
    if (isNaN(value)) value = "";
    setBet(v);

    if (value < minBet) setErr("Minimum bet is 0.5 USDT");
    else if (value > maxBet)
      setErr(`Insufficient balance (max: ${maxBet} USDT)`);
    else setErr("");
  };

  const handleSend = () => {
    const value = Number(bet);
    if (value < minBet) {
      setErr("Minimum bet is 0.5 USDT");
      return;
    }
    if (value > maxBet) {
      setErr(`Insufficient balance (max: ${maxBet} USDT)`);
      return;
    }
    setErr("");
    onSend(value);
    onClose();
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
      <div className="bg-[#161e2e] rounded-3xl shadow-2xl p-8 max-w-xs w-full flex flex-col items-center border-2 border-lime-400/40 relative">
        <h2 className="font-black text-xl mb-4 text-lime-300 tracking-wide drop-shadow-lg text-center">
          Enter Bet Amount
        </h2>
        <input
          type="number"
          min={minBet}
          max={maxBet}
          step="0.1"
          className="border-2 border-lime-400 rounded-xl bg-[#1e293b] text-2xl font-bold text-lime-300 text-center px-4 py-2 mb-2 w-full outline-none shadow-md focus:ring-2 focus:ring-lime-500 transition-all"
          value={bet}
          onChange={handleChange}
          placeholder={`Min ${minBet}, Max ${maxBet}`}
        />
        {err && (
          <div className="text-pink-400 text-xs font-bold mt-1 mb-2">{err}</div>
        )}
        <div className="flex gap-3 w-full mt-2">
          <button
            onClick={handleSend}
            className={`flex-1 rounded-xl py-2 text-lg font-extrabold shadow-md transition-all duration-150 
              ${
                err || !bet
                  ? "bg-gray-400 text-white cursor-not-allowed"
                  : "bg-gradient-to-r from-lime-400 via-lime-500 to-green-500 text-white hover:scale-105 hover:shadow-xl"
              }
            `}
            disabled={!!err || !bet}
          >
            Send Invite
          </button>
          <button
            onClick={onClose}
            className="flex-1 rounded-xl py-2 text-lg font-bold bg-gray-200 text-gray-700 hover:bg-gray-300 transition-all"
          >
            Cancel
          </button>
        </div>
        <p className="text-xs text-slate-400 mt-3 italic">
          Min: <span className="text-lime-400 font-bold">{minBet} USDT</span>
          {" | "}
          Max: <span className="text-lime-400 font-bold">{maxBet} USDT</span>
          {maxBalance && (
            <>
              <br />
              Your balance:{" "}
              <span className="text-lime-300 font-bold">
                {maxBalance.toFixed(2)} USDT
              </span>
            </>
          )}
          <br />
          <span className="text-pink-300">
            (You must keep at least 0.5 USDT after sending an invite)
          </span>
        </p>
        <span
          onClick={onClose}
          className="absolute top-2 right-3 text-lime-300 text-xl font-black cursor-pointer hover:text-pink-400"
          title="Close"
        >
          ×
        </span>
      </div>
    </div>
  );
}
